import style from './outOfStock.module.scss';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SearchIcon from '@assets/images/Fireboard/Search';
import { useState } from 'react';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const SearchStock = ({
  searchOutOfStockItems,
  selectedTab,
  searchedItemsList,
  outOfStockItems,
  outOfStockSearchList,
  setPopup,
  getConfirmation,
  cartItems,
}) => {
  const [fieldValue, setFieldValue] = useState('');

  const search = () => {
    if (fieldValue.trim().length === 0) return;
    searchOutOfStockItems &&
      searchOutOfStockItems(selectedTab, fieldValue.trim());
    setFieldValue('');
  };

  const onSubmit = e => {
    e.preventDefault();
    search();
  };

  return (
    <div className="h-100 d-flex flex-column">
      <form className="position-relative" onSubmit={onSubmit}>
        <input
          type="text"
          value={fieldValue}
          onChange={e => setFieldValue(e.target.value)}
          className={cn(style.searchInput, 'col-12 pl-3 pr-5')}
          placeholder={FLABEL().OOS_SEARCH}
        />
        <div className={style.searchIcon} onClick={search}>
          <SearchIcon />
        </div>
      </form>

      {Array.isArray(outOfStockSearchList) &&
      outOfStockSearchList.length > 0 ? (
        <div className={cn(style.itemsContainer)}>
          {outOfStockSearchList.map(item => {
            const isOutOfStock = outOfStockItems.find(i => i.id === item.id);
            const isAlredyInCart = cartItems.find(el => el.id === item.id);
            return (
              <div
                key={`searchItem-${item.id}`}
                className={cn(style.searchItem, {
                  [style.disabled]: !item.stocked || isAlredyInCart,
                })}
                onClick={() => getConfirmation(item)}
              >
                {isOutOfStock && <div className={style.stockOutSign}>86</div>}
                <div className={cn(style.posId, 'text-center')}>
                  {item.posId}
                </div>
                <div className="text-center pt-1 text-truncate">
                  {item.name}
                </div>
              </div>
            );
          })}
        </div>
      ) : Array.isArray(outOfStockSearchList) &&
        outOfStockSearchList.length === 0 ? (
        <div
          className={cn(
            style.itemsContainer,
            'd-flex justify-content-center align-items-center'
          )}
        >
          <div
            className={cn(
              'd-flex justify-content-center align-items-center text-center w-100',
              style.notFound
            )}
          >
            {selectedTab === 'items'
              ? FLABEL().OOS_NO_ITEMS_FOUND
              : FLABEL().OOS_NO_MODIFIERS_FOUND}
          </div>
        </div>
      ) : null}
    </div>
  );
};

SearchStock.propTypes = {
  searchOutOfStockItems: PropTypes.func.isRequired,
  selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  searchedItemsList: PropTypes.array.isRequired,
  outOfStockItems: PropTypes.array.isRequired,
  outOfStockSearchList: PropTypes.array.isRequired,
  setPopup: PropTypes.func.isRequired,
  getConfirmation: PropTypes.func.isRequired,
  cartItems: PropTypes.array.isRequired,
};


export default SearchStock;
